import apiService from '../Api'
import { DutyPlanner, DutyPlannerInput, DutyPlannerListParams, DutyPlannerListType } from './types'

export class DutyPlannerService {
  async list(params: DutyPlannerListParams): Promise<DutyPlannerListType> {
    return apiService
      .get('/duty-planner', {
        params
      })
      .then((res) => res.data)
  }

  async get(id: number): Promise<DutyPlanner> {
    return apiService.get(`/duty-planner/${id}`).then((res) => res.data)
  }

  async create(data: DutyPlannerInput): Promise<DutyPlanner> {
    return apiService.post('/duty-planner', data).then((res) => res.data)
  }

  async update(id: number, data: DutyPlannerInput): Promise<DutyPlanner> {
    return apiService.put(`/duty-planner/${id}`, data).then((res) => res.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/duty-planner/${id}`).then((res) => res.data)
  }
}
